import { useMutation } from '@tanstack/react-query';
import { getBriefingQuery } from '../services/briefingService';

// The spoken summaries. They aren't kept in the cache: one is asked for when someone presses a button, and the server remembers
// recent ones for repeats.
export const briefingMutation = (boardId: string) => ({
    mutationFn: (request: Parameters<typeof getBriefingQuery>[1]) => getBriefingQuery(boardId, request),
});

export const useBriefing = (boardId: string) => useMutation(briefingMutation(boardId));
